const state = {
  showEditGroupAbility: false,
  showAddGroupAbility: false,
  showSetUsersGroupAbility: false,
  showSetAclsGroupAbility: false
}

const getters = {
  getShowEditGroupAbility: state => state.showEditGroupAbility,
  getShowAddGroupAbility: state => state.showAddGroupAbility,
  getShowSetUsersGroupAbility: state => state.showSetUsersGroupAbility,
  getShowSetAclsGroupAbility: state => state.showSetAclsGroupAbility
}

const actions = {
}

const mutations = {
  'SHOW_EDIT_GROUPABILITY_POPUP': (state, showEditGroupAbility) => { state.showEditGroupAbility = showEditGroupAbility },
  'SHOW_ADD_GROUPABILITY_POPUP': (state, showAddGroupAbility) => { state.showAddGroupAbility = showAddGroupAbility },
  'SHOW_SETUSERS_GROUPABILITY_POPUP': (state, showSetUsersGroupAbility) => { state.showSetUsersGroupAbility = showSetUsersGroupAbility },
  'SHOW_SETACLS_GROUPABILITY_POPUP': (state, showSetAclsGroupAbility) => { state.showSetAclsGroupAbility = showSetAclsGroupAbility },
  'test': (state) => { console.log('tt') }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
